import { render, staticRenderFns } from "./EditEventPage.vue?vue&type=template&id=5cb33d80&scoped=true"
import script from "./EditEventPage.vue?vue&type=script&lang=ts"
export * from "./EditEventPage.vue?vue&type=script&lang=ts"
import style0 from "./EditEventPage.vue?vue&type=style&index=0&id=5cb33d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb33d80",
  null
  
)

export default component.exports